export * from "./browser";
export * from "./form";
export * from "./headspace";
export * from "./interfaces";
export * from "./misc";
export * from "./observe-intersection";
export * from "./regex";
export * from "./utils/dispatch";

export function exportGlobal(exports: object, globalObject: object = globalThis) {
  Object.entries(exports).forEach(([k, v]) => (globalObject[k] = v));
}

export function matchMediaExec(query: string, func: Function, altFunc: Function | null = null) {
  const m = query.match(/^\(width[\s]+<[\s]+(?<value>[\d]+[\w]+)\)/);
  if (m?.groups) {
    // Support for `(width < ???px)` [Safari < 16.4]
    // @see https://caniuse.com/css-media-range-syntax
    query = `not all and (min-width: ${m.groups.value})`;
  }
  if (window.matchMedia(query).matches) {
    return func();
  }
  return altFunc?.();
}
